import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageMyFavs
{
    constructor(targetElement)
    {
        this.getMyFavs();
    }

    getMyFavs(filter)
    {
        api.get("myfavs", (result) =>
        {
            let html = "";
            for (const i in result)
            {
                const project = result[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            ele.byId("myfavs").innerHTML = html;
        });
    }
}

